"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShapeTypes = void 0;
var ShapeTypes;
(function (ShapeTypes) {
    ShapeTypes["Polygon"] = "polygon";
    ShapeTypes["StarBurst"] = "starBurst";
    ShapeTypes["Ellipse"] = "ellipse";
    ShapeTypes["Rectangle"] = "rectangle";
    ShapeTypes["Line"] = "line";
    ShapeTypes["Arrow"] = "arrow";
    ShapeTypes["DoubleSidedArrow"] = "doubleSidedArrow";
    ShapeTypes["CircularSpeechBubble"] = "circularSpeechBubble";
    ShapeTypes["SpeechBubble"] = "speechBubble";
})(ShapeTypes = exports.ShapeTypes || (exports.ShapeTypes = {}));
//# sourceMappingURL=types.paths.js.map